var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExclude(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dsdf 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7---new-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-940.000000, -852.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dsdf-2",
    transform: "translate(938.750429, 850.750674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dsdf",
    transform: "translate(6.500000, 6.500000) rotate(76.000000) translate(-6.500000, -6.500000) translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-action-/-plus",
    transform: "translate(4.681336, 5.803307) rotate(-15.000000) translate(-4.681336, -5.803307) translate(2.681336, 1.303307)",
    fill: "#001247",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    transform: "translate(1.693478, 4.266190) rotate(-15.000000) translate(-1.693478, -4.266190) ",
    points: "1.1008851 0.266190113 2.28607029 0.266190113 2.28607029 8.26619011 1.1008851 8.26619011"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#001247",
    cx: 4.13394707,
    cy: 5.30727716,
    r: 4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclude);
export default __webpack_public_path__ + "static/media/icon-exclude.2be3d27d.svg";
export { ForwardRef as ReactComponent };